module.exports = __webpack_public_path__ + "407cbab9c2d5d15ee970b03cd16b8779.fbx";